import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBambooLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_198_11317)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.034 16.92C12.486 16.92 11.172 15.696 11.172 14.064C11.172 12.426 12.276 11.082 14.058 11.082C15.84 11.082 16.89 12.522 16.89 14.034C16.896 15.678 15.78 16.92 14.034 16.92ZM9.462 11.502L8.916 9.708C8.592 8.766 8.49 8.22 7.572 7.248C7.254 6.912 6.06 6.18 6.21 6.342C7.722 7.974 8.496 9.954 8.796 10.506C8.52 10.176 8.202 9.876 7.836 9.504C7.524 9.186 7.2 8.904 6.888 8.712C6.684 8.586 6.57 8.514 6.36 8.412C5.43 7.926 4.524 7.632 4.176 7.548C3.75 7.44 3.336 7.416 3.336 7.416C3.336 7.416 4.686 8.556 5.268 9.282C5.844 10.008 6.438 10.656 7.092 10.926C7.746 11.19 7.974 11.268 8.484 11.346C8.922 11.4 9.462 11.502 9.462 11.502ZM14.154 9.912C12.726 9.912 11.958 10.404 11.424 10.938L11.28 11.094V6.306H10.044V14.142C10.044 16.554 11.898 18.054 14.034 18.054C16.38 18.054 18.156 16.248 18.156 13.926C18.156 11.766 16.302 9.912 14.154 9.912ZM24 12C24 18.63 18.63 24 12 24C5.37 24 0 18.63 0 12C0 5.37 5.37 0 12 0C18.63 0 24 5.37 24 12Z",
				fill: "#73C41D"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_198_11317",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgBambooLogo);
export { ForwardRef as ReactComponent };
